import { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import { generateSearchUrl } from './search-helpers'
import useSearchHistory from './use-search-history'

import { useCategoryModal } from '../../category-modal/context/category-modal-context'
import { useSearchModal } from '../context/search-modal-context'

interface Params {
    query: string
    setQuery: (query: string) => void
    onSubmit?: () => void
}

export const useSearchSubmit = ({ onSubmit, query, setQuery }: Params) => {
    const { close: closeSearchModal, isOpen: isSearchModalOpen } = useSearchModal()
    const { close: closeCategoryModal, isOpen: isCategoryModalOpen } = useCategoryModal()
    const { addItemToSearchHistory } = useSearchHistory()
    const router = useRouter()

    return useCallback(
        (e: React.FormEvent) => {
            e.preventDefault()

            onSubmit?.()

            if (!query.length) {
                closeCategoryModal()
                closeSearchModal()
                return
            }

            const trimmedQuery = query.trim()

            setQuery(trimmedQuery)
            addItemToSearchHistory(trimmedQuery)

            if (isCategoryModalOpen && isSearchModalOpen) {
                history.go(-1)
            }

            closeCategoryModal()
            closeSearchModal(false)

            setTimeout(() => {
                router.replace(generateSearchUrl(trimmedQuery))
            })
        },
        [
            onSubmit,
            query,
            setQuery,
            addItemToSearchHistory,
            router,
            closeSearchModal,
            closeCategoryModal,
            isCategoryModalOpen,
            isSearchModalOpen,
        ]
    )
}
